module.exports = __webpack_public_path__ + "static/media/company-purchase-background.a83fe264.png";